import React from 'react'
import { ChevronDown, Users, Calendar, MapPin } from 'lucide-react'

function SectorSelector({ 
  availableSectors, 
  selectedSector, 
  onSectorChange, 
  loading 
}) {
  if (availableSectors.length === 0) {
    // Don't show selector if no sectors available
    return null;
  }

  return (
    <div className="sector-selector">
      <label htmlFor="sector-select" className="sector-label">
        <MapPin size={16} />
        Select Industry Sector:
      </label>
      
      <div className="select-wrapper">
        <select
          id="sector-select"
          value={selectedSector}
          onChange={(e) => onSectorChange(e.target.value)}
          disabled={loading}
          className="sector-select"
        >
          {availableSectors.map(sector => (
            <option key={sector.id} value={sector.id}>
              {sector.name} ({sector.country})
            </option>
          ))}
        </select>
        <ChevronDown size={16} className="select-icon" />
      </div>

      {/* Show sector stats */}
      {selectedSector && availableSectors.length > 0 && (
        <div className="sector-stats">
          {(() => {
            const sector = availableSectors.find(s => s.id === selectedSector);
            if (!sector) return null;
            
            return (
              <div className="stats-grid">
                <div className="stat-item">
                  <Users size={14} />
                  <span>{sector.totalOrganisations} organisations</span>
                </div>
                <div className="stat-item">
                  <Calendar size={14} />
                  <span>{sector.totalConferences} conferences</span>
                </div>
                {sector.lastUpdated && (
                  <div className="stat-item">
                    <span className="update-time">
                      Updated: {new Date(sector.lastUpdated).toLocaleDateString()}
                    </span>
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
}

export default SectorSelector;